import { useEffect, useState } from "react";
import { getBranding } from "../services/branding";

// Ownezzy's logos in the admin panel: the ones a Super Admin uploaded (Settings -> Ownezzy logos), or the files
// shipped in public/brand. Loaded once and shared, so a new upload shows everywhere straight away.
export const DEFAULT_LOGOS = { logo: "/brand/logo-192.png", logoWide: "/brand/logo-wide.jpg", favicon: "/brand/favicon-32.png" };

let current = null;
let loading = null;
const listeners = new Set();

function setFavicon(href) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

// Ownezzy's contact ({ email, whatsapp }), set by a Super Admin (Settings -> Configuration); null until loaded
let contact = null;
const contactListeners = new Set();

// Called with the API's { logo, logoWide, favicon } (null = the shipped file)
export function setBranding(branding) {
  current = Object.fromEntries(Object.keys(DEFAULT_LOGOS).map((kind) => [kind, (branding && branding[kind]) || DEFAULT_LOGOS[kind]]));
  setFavicon(current.favicon);
  listeners.forEach((listener) => listener(current));
}

function setContact(next) {
  contact = next || {};
  contactListeners.forEach((listener) => listener(contact));
}

// GET /api/branding brings both the logos and the contact, once for the whole panel
function load() {
  if (!loading) {
    loading = getBranding()
      .then(({ data }) => { setBranding(data.branding); setContact(data.contact); })
      .catch(() => { setBranding(null); setContact(null); });
  }
}

export function useBranding() {
  const [logos, setLogos] = useState(current || DEFAULT_LOGOS);
  useEffect(() => {
    listeners.add(setLogos);
    load();
    if (current) setLogos(current);
    return () => listeners.delete(setLogos);
  }, []);
  return logos;
}

// { email, whatsapp } of Ownezzy support ({} until loaded: supportLink then uses its default number)
export function useOwnezzyContact() {
  const [value, setValue] = useState(contact || {});
  useEffect(() => {
    contactListeners.add(setValue);
    load();
    if (contact) setValue(contact);
    return () => contactListeners.delete(setValue);
  }, []);
  return value;
}
